import { createFileRoute } from '@tanstack/react-router';

import { FamilyHubStudentLinks } from '~features/family-hub/ui/family-hub-student-links';

const Component = () => {
  const { familyId } = Route.useParams();
  return <FamilyHubStudentLinks familyId={familyId} tab='classes' />;
};

export const Route = createFileRoute(
  '/_auth/_layout/families/$familyId/classes',
)({
  component: Component,
});
